import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from '../../../components/AsyncComponent';

const EyeglassLensTypeWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/order/inventory/eyeglassLensType/EyeglassLensTypeWrap')
)
const EyeglassLensMaterialWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/order/inventory/eyeglassLensMaterial/EyeglassLensMaterialWrap')
)
const EyeglassLensFrameWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/order/inventory/eyeglassLensFrame/EyeglassLensFrameWrap')
)
const EyeglassAddOnWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/order/inventory/eyeglassAddOn/EyeglassAddOnWrap')
)
const StockLensWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/order/inventory/stockLenses/StockLensWrap')
)
const MiscItemWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/order/inventory/miscItems/MiscItemWrap')
)
const ContactLensWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/exam/formValues/contactLens/ContactLensWrap')
)
const ContactLensCleaningSolutionWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/exam/formValues/contactLensCleaningSolution/ContactLensCleaningSolutionWrap')
)
const PromiseDate = asyncComponent(() =>
  import('../../../containers/authorised/setting/orderSettings/PromiseDate')
)
const OrderForm = asyncComponent(() =>
  import('../../../containers/authorised/setting/orderSettings/OrderForm')
)
const PromotionWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/orderSettings/promotions/PromotionWrap')
)
const Warranty = asyncComponent(() =>
  import('../../../containers/authorised/setting/orderSettings/Warranty')
)
const InventoryTransferWarehousesWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/order/inventoryTransfer/warehouses/WarehousesWrap')
)
const InventoryTransferInventoryWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/order/inventoryTransfer/inventory/WarehouseInventoryWrap')
)
const InventoryTransferTransfersWrap = asyncComponent(() =>
  import('../../../containers/authorised/setting/order/inventoryTransfer/transfers/TransfersWrap')
)
const OrderRoutes = (
  <Switch>
    <Route exact path="/settings/order/promise-date" component={PromiseDate} />
    <Redirect exact from="/settings/order" to="/settings/order/promise-date" />
    <Route exact path="/settings/order/order-form" component={OrderForm} />
    <Route exact path="/settings/order/promotions" component={PromotionWrap} />
    <Route exact path="/settings/order/warranty" component={Warranty} />
    <Route exact path="/settings/inventory-transfer" component={InventoryTransferWarehousesWrap} />
    <Route exact path="/settings/inventory-transfer/inventory" component={InventoryTransferInventoryWrap} />
    <Route exact path="/settings/inventory-transfer/transfers" component={InventoryTransferTransfersWrap} />

    <Route exact path="/settings/order-inventory/eyeglass" component={EyeglassLensTypeWrap} />
    <Route exact path="/settings/order-inventory/eyeglass/lens-material" component={EyeglassLensMaterialWrap} />
    <Route exact path="/settings/order-inventory/eyeglass/lens-frame" component={EyeglassLensFrameWrap} />
    <Route exact path="/settings/order-inventory/eyeglass/add-ons" component={EyeglassAddOnWrap} />
    <Route exact path="/settings/order-inventory/stock-lenses" component={StockLensWrap} />
    <Route exact path="/settings/order-inventory/misc" component={MiscItemWrap} />
    <Redirect exact from="/settings/order-inventory" to="/settings/order-inventory/eyeglass" />
    {/* ContactLens */}
    <Route exact path="/settings/orders-inventory/contact-lens" component={ContactLensWrap} />
    <Route exact path="/settings/orders-inventory/contact-lens/cleaning-solution" component={ContactLensCleaningSolutionWrap} />
  </Switch>
);

export default OrderRoutes;
